import React, { useEffect, useContext, useRef, useState } from "react"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { generateBI, saveApplication, fetchApplicationDetails, pdfDownload, sendEmailBI, getConfigurationsByType } from "../../services/apiservice"
import {findCurrentJourneyCode, DataLayerIntegration, isEquitasChannel} from "../services/helperFunctions"
import { errorToastr, successToastr, clearToastr } from "../../services/error-handler";
import * as lookup from "../../../static/lookup.json";
import { applyComma, insWords } from '../../shared/functions'

import RightSideBar from '../sections/section-right-side-bar'
import { ErrorContext } from "../context/errorContext";

import DocListPDF from "../../documents/List-of-acceptable-documents.pdf";

export default function ChooseYourPlanYoungTerm(props) {
  const [activeTab, setActiveTab] = useState("calculatePremium")
  const [sectionLocalState, setSectionLocalState] = useState("calculatePremium")

  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  // const [conditionState, setConditionState] = useContext(ConditionContext)
  const [apiResult, setApiResult] = useState();
  const [optionData,setOptionData] = useState()
  const [selectedOption, setSelectedOption] = useState()
  const [errorState, setErrorState] = useContext(ErrorContext);
  const [message, setMessage] = useState();
  let arr = {}
  let [premiumOption, setPremiumOption] = useState("calculatePremium")
  const [gstRate, setGstRate] = useState(null);
  const copyTimeoutRef = useRef(null)
  const copyElementRef = useRef(null)

  useEffect(() => {
    return () => {
      if (copyTimeoutRef.current) {
        clearTimeout(copyTimeoutRef.current)
      }
    }
  }, [])

  const downloadPdf = async (transactionId) => {
    // let pdfResult = await pdfDownload({
    //   applicationNumber: journeyState.applicationNo,
    //   TID: transactionId || "",
    // })
    // setPdfData(pdfResult.data.Base64Pdf)
    // let sendEmailPayload ={
    //   journeyId: journeyState.journeyId,
    //   module: "QUOTESMSEMAIL",
    //   BIPDF: pdfResult.data.Base64Pdf
    // }
    // let leadGeneratorPayload ={
    //   journeyId: journeyState.journeyId,
    //   module: "LEADSMS"
    // }
    // sendEmailBI(leadGeneratorPayload).then(res => {
    //   console.log('121212')
    // }).catch(e=>{
    //   console.log("skjhkjhds")
    // })
    // sendEmailBI(sendEmailPayload).then(res => {
    //   console.log(res, "emailRes")
    //   if(res?.status){
    //     successToastr(res.message)
    //   }else{
    //     errorToastr(res.message)
    //   }
    // })
  }

  const asyncGenerateBi = async () => {
    if(journeyState.journeyId && props.callBi){
      let payloadForApplicationDetails = {
        _id : journeyState.journeyId,
      }
      fetchApplicationDetails(payloadForApplicationDetails).then( async res => {
        console.log(res, "fhggkgjd")
        let payload = {
          journeyId: journeyState.journeyId,
          recommendedOptions: true,
          dob: res?.applicationData?.[0]?.pageData?.[0]?.sectionData?.dob,
          policyTerm: res?.applicationData?.[0]?.pageData?.[0]?.sectionData?.policyTerm,
          sumAssured: res?.applicationData?.[0]?.pageData?.[0]?.sectionData?.sumAssured,
          AnnualIncome: res?.applicationData?.[0]?.pageData?.[0]?.sectionData?.AnnualIncome,
          callSendEmailBi: journeyState.premium ? false : true,
          planOption: journeyState.planOption
        }
        let data
        
        try {
          data = await generateBI(payload);
        }catch(err){
          console.log("error while generating bi choose your plan section", err)
        }
        
        console.log(data?.data, "data from generate bi")
        props.setCallBi(false)
        if (data?.data?.BIJson) {
          console.log("inside if");
          let temp = {
            premium: (data.data?.finalKeys?.INSTALLMENT_PREM_LA_RIDER) || 0,
            totalPremium: (data.data?.finalKeys.PREMIUM)|| 0,
            lumpsumAmount: data.data.sumAssured,
            POLICYTERM: data.data.finalKeys?.POLICYTERM,
            BIJson: data.data.BIJson,
            TransactionId: data.data.TransactionId
          }
          // if(!journeyState.premium){
          //   downloadPdf(data.data.TransactionId)
          // }
          // journeyState["premium"] = temp.totalPremium
          setApiResult(temp)
          setSelectedOption(temp)
          setJourneyState(prev => {
            return {
              ...prev,
              premium: temp.totalPremium,
              premiumOption : premiumOption,
            }
          })
        }else{
          if(data?.data?.InputValidationStatus && data?.data?.InputValidationStatus[0]?.ErrorMessage){
            const str = data?.data?.InputValidationStatus[0]?.ErrorMessage.map(el => el.value).join(',')
            setMessage(str);
            return;
          }
          else{
            setMessage(data?.data?.Message);
            return;
          }
        }
        if(data.optionData){
          let temp = {}
          if(data.optionData.option1 && data.optionData.option1.BIJson){
            let option1Data = {
              premium: (data.optionData.option1.finalKeys.TOTAL_INSTALLMENT) || 0,
              totalPremium: (data.optionData.option1.finalKeys.PREMIUM) || 0,
              lumpsumAmount: data.optionData.option1.sumAssured,
              POLICYTERM: data.optionData.option1.finalKeys.POLICYTERM,
              BIJson:  data.optionData.option1.BIJson,
              TransactionId: data.optionData.option1.TransactionId
            }
            temp["option1Data"] = option1Data
          }
          if(data.optionData.option2 && data.optionData.option2.BIJson){
            let option2Data = {
              premium: (data.optionData.option2.finalKeys.TOTAL_INSTALLMENT) || 0,
              totalPremium: (data.optionData.option2.finalKeys.PREMIUM)|| 0,
              lumpsumAmount: data.optionData.option2.sumAssured,
              POLICYTERM: data.optionData.option2.finalKeys.POLICYTERM,
              premiumPaymentTerm:  data.optionData.option2.premiumPaymentTerm,
              BIJson:  data.optionData.option2.BIJson,
              TransactionId: data.optionData.option2.TransactionId
            }
            temp["option2Data"] = option2Data
          }
          setOptionData(temp)
        }
      })
      
    }
  }

  const handleCopyLink = async (event) => {
    const copyTarget = event?.currentTarget
    const copyUrl = copyTarget?.dataset?.copyUrl
    if (!copyUrl) return

    let isCopied = false
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(copyUrl)
        isCopied = true
      }
    } catch (error) {}

    if (!isCopied) {
      const textarea = document.createElement("textarea")
      textarea.value = copyUrl
      document.body.appendChild(textarea)
      textarea.select()
      isCopied = document.execCommand("copy")
      document.body.removeChild(textarea)
    }

    if (!isCopied) return

    const defaultLabel = "Click here to copy url"
    if (copyElementRef.current && copyElementRef.current !== copyTarget) {
      copyElementRef.current.textContent = defaultLabel
    }

    copyTarget.textContent = "Copied"
    copyElementRef.current = copyTarget

    if (copyTimeoutRef.current) {
      clearTimeout(copyTimeoutRef.current)
    }
    copyTimeoutRef.current = setTimeout(() => {
      if (copyElementRef.current) {
        copyElementRef.current.textContent = defaultLabel
        copyElementRef.current = null
      }
    }, 2000)
  }

  useEffect(() => {
    asyncGenerateBi()
  }, [journeyState.journeyId, props.callBi])

  useEffect(() => {
      if (!journeyState?.journeyIdFromStrapi) return;
  
      getConfigurationsByType({ type: "gst-config" })
        .then(res => {
          const allRates = res?.data?.[0]?.config?.planWiseGSTRates || {};
          const journeyId = journeyState.journeyIdFromStrapi;
  
          // pick GST rates for this journey
          const journeyRates = allRates[journeyId] || null;
          setGstRate(journeyRates);
        })
        .catch(err => {
          console.error("Failed to fetch GST config", err);
        });
    }, [journeyState?.journeyIdFromStrapi]);

  const handlePrevious = () => {
    let e ="previous"
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, e, props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    setSectionState({
      sectionId: null,
      sectionData: {},
    })
    
    // journeyState["paymentFrequency"] = "01";
    //handeling context change
    if (pageState.pageId === props.pages[props.currentPageIndex].pageId) {
      pageState.pageData.map((element, index) => {
        if (
          element.sectionId ===
          props.sections[props.currentSectionIndex - 1].sectionId // setting section context from page context
        ) {
          setSectionState(prev => {
            return {
              ...prev,
              sectionId: element.sectionId,
              sectionData: element.sectionData,
            }
          })
        }
      })
    }
    setJourneyState(prev => {
      return {
        ...prev,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex].sectionId)
      }
    })
    props.setCurrentSectionIndex(prev => prev - 1)
  }

  const handleProceed = () => {
    if(!apiResult){
      errorToastr(message);
      return;
    }
    let e ="proceed"
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, e, props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)

    let tempSectionStateData = {
      sectionId: props.sections[props.currentSectionIndex].sectionId,
      sectionData: {
        ...selectedOption
      },
    }

    //console.log("is section ID null")
    if (pageState.pageId === props.pages[props.currentPageIndex].pageId) {
      let foundSection = pageState.pageData.find(
        //to prevent duplicate section
        element => element.sectionId === tempSectionStateData.sectionId
      )
      //console.log(foundSection, "foundSection")

      if (foundSection) {
        // removing the old section to add new section
        let newPageData = pageState.pageData.filter(
          element => element.sectionId !== foundSection.sectionId
        )
        setPageState(prev => {
          return {
            ...prev,
            pageData: newPageData, //newPageData has all sections except founded section
          }
        })
        foundSection = {}
      }

      setPageState(prev => {
        return {
          ...prev,
          pageData: [...prev.pageData, tempSectionStateData], // adding new section
        }
      })
    } else {
      setPageState(prev => {
        // case of new page
        return {
          ...prev,
          pageId: props.pages[props.currentPageIndex].pageId,
          pageData: [...prev.pageData, tempSectionStateData],
        }
      })
    }

    setSectionState(prev => {
      // making section data empty to load new sectionData
      return {
        ...prev,
        
        sectionFirstPass: null,
        sectionData: {},
      }
    })

    pageState.pageData.map((element, index) => {
      if (
        element.sectionId ===
        props.sections[props.currentSectionIndex + 1].sectionId
      ) {
        //loading section state if already present
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: element.sectionId,
            sectionData: element.sectionData,
          }
        })
      }
    })

    console.log(sectionState, "section state")
    console.log(pageState, "pageState")
    console.log(journeyState, "journey state else")

    props.setCurrentSectionIndex(prev => prev + 1)

    setJourneyState(prev => {
      return {
        ...prev,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        premium: selectedOption?.totalPremium,
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex].sectionId)
      }
    })

    //saving application data
    let pageData = pageState.pageData.filter(
      element => element.sectionId !== tempSectionStateData.sectionId
    )
    let journeyData = journeyState.journeyData.filter(
      element => element.pageId !== props.pages[props.currentPageIndex].pageId
    )

    let LoadPaylod = [
      ...journeyData,
      {
        pageId: props.pages[props.currentPageIndex].pageId,
        pageData: [...pageData, tempSectionStateData],
      },
    ]

    //console.log(firstLoadPaylod)
    setJourneyState(prev => {
      return {
        ...prev,
        BITransactionId: selectedOption?.TransactionId,
      }
    });
    let sendPayload = {
      applicationData: LoadPaylod,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex + 1,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        planOption : journeyState.planOption,
        journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
        proposalEntryId: journeyState.proposalEntryId,
        premium: selectedOption.totalPremium,
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        BITransactionId: selectedOption?.TransactionId,
        journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex].sectionId),
        premiumOption: premiumOption
      },
    }
    saveApplication(sendPayload).then(res => {
      //console.log(res)
    }).catch(error => {
      console.log("asdsadasd", errorState)
        setSectionState({
          sectionId: sectionState.sectionId,
          sectionData: sectionState.sectionData
        })
        props.setCurrentSectionIndex(prev => prev - 2)
        setErrorState({})
    })
  }

  const createCardSet = () => {
    let cardContainers = document.querySelectorAll(".radio-card-container")

    cardContainers.forEach(cardContainer => {
      cardContainer.querySelectorAll("[data-active-class]").forEach(el => {
        let dataActiveClass = el.getAttribute("data-active-class")
        if (arr[dataActiveClass]) {
          arr[dataActiveClass] = [...arr[dataActiveClass], el]
        } else {
          arr[dataActiveClass] = [el]
        }
      })
    })
  }
  createCardSet()

  const handleActiveTab = ({ target }, value) => {
    console.log({ target, value })
    if (target.getAttribute("data-active-tab")) {
      Array.from(target.parentElement.parentElement.children).forEach(el => {
        el.classList.remove("active-tab")
      })
      target.parentElement.classList.add("active-tab")
      setActiveTab(value)
    }
  }

  const handleEnter = (event,{ target }, isCard)=>{
    handleChange({ target }, isCard)
      if(event.key == 'Enter'){
    }
  }

  const handleChange = ({ target }, isCard) => {
    setSectionLocalState(target.value)
    // setConditionState(prev => {
    //   return {
    //     ...prev,
    //     [`${props.pageId}.${props.sectionId}.${apiData.formControlKey}`]: target.value,
    //   }
    // })

    if (target.value && isCard) {
      console.log(target.value)
      let currentRadio = document
        .getElementById(target.value)
        .querySelector("[data-active-class]")
      console.log(currentRadio)
      // let parent = currentRadio.parentElement.querySelectorAll(".radio-card")

      // removing other active class
      let radios = arr[currentRadio.getAttribute("data-active-class")]
      radios?.forEach(radio => {
        radio.classList.remove("active")
      })

      // activate radio Radio
      currentRadio.classList.add("active")
      setPremiumOption(target.value)
      setJourneyState(prev =>{
        return{
          ...prev,
          premiumOption : premiumOption,
      }
      })
    }
  }

  const standardCapital = (input)=>{
    if(input){
       var str = input?.split(" "); 
      var expected = "";
      str?.map(function(c){
        expected += c?.toLowerCase()?.replace(/^[a-z]/, c[0]?.toUpperCase())+ " "
      })
      expected = expected?.trim(); 
      return expected;
    }
  }

  // code of tab enter
  const handleEnterPrevious = (event) =>{
    if(event?.key == 'Enter'){
      handlePrevious();
    }
  }

  return (
    <>
      <style>
        {`
        .radio-tab {
          display: flex;
          justify-content:space-evenly;
          margin-bottom:2rem;
          border:1px solid black;
        }

        //bootstrap 5 changes
        
          .chooseYourPlan .divider-card-2::after{
          height:245px !important;
        }
        .chooseYourPlan{
          display:flex;
          flex-wrap:wrap;
        }
        .chooseYourPlan .radio-card{
          padding:0 20px;
        }
        .forbottomline .total-prem-payment-price{
          position:relative;
        }
        
        @media screen and (max-width:992px){
          .w100medium{
            width:100% !important;
           }
           .col-md-6{
            width:100% !important;
           }
           .field.col-md-12{
          width:100% !important;
           }
          }
        .radio-tab > *{
          color:black;
          background:transparent;
          padding:0;
          flex:1;
          padding: 4px 0;

        }

        .radio-tab p{
          margin:0;
          
        }

        .active-tab{
          background-color: ${journeyState.channel === "A" ? "#000000" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"};
          background-color: var(--lumiq-secondary);
          color:white
        }
        .card-label {
          height:3rem;
          text-align:center;
          font-weight:bold;
        }

        .choose-plan-border{
          position:relative;
          
        }

        .choose-plan-border::after{
          position:absolute;
          content:'';
          width:1px;
          background:#ccc;
          height:42rem;
          top:0;
          right:0;

        }

        @media screen and (max-width:991px){
          .choose-plan-border::after{
            background-color: transparent;
          }
        }

       
  
        

        
        `}
      </style>
      {/* <Header /> */}
      <div className="landing-page1-design">
        <div key={props.sections[props.currentSectionIndex].sectionId}>
          <div className="container">
            <div className="row">
              <div className={`col-md-9 w100medium ${apiResult?'choose-plan-border':'brd-right'}` } >
                <div>
                  <div className="heading-design" style={{marginBottom:'3rem'}} >
                    <div className="iselect-padding left-side-head ckyc-w">
                      <h1 className="iselect-heading">Choose Your Plan</h1>
                    </div>
                  </div>
                  {apiResult ? (
                    <div className="iselect-padding">
                      <div className="row radio-card-container ">
                        <div className="col-md-11">

                        <div className="radio-tab d-md-none d-lg-none">
                          {[
                            {
                              label: "Calculated Premium",
                              value: "calculatePremium",
                              name: "calculatePremium",
                            },
                            {
                              label: "Other Recommended Options",
                              value: "recommendedOption",
                              name: "recommendedOption",
                            },
                          ].map((el, i) => {
                            if (el.label) {
                              return (
                                <div
                                  className={`${
                                    activeTab == el.name ? "active-tab" : ""
                                  }`}
                                >
                                  <p
                                    data-active-tab={el.value}
                                    aria-hidden="true"
                                    onClick={e => handleActiveTab(e, el.name)}
                                    className="text-center"
                                    style={{ fontSize: "1rem" }}
                                  >
                                    {el.label}
                                  </p>
                                </div>
                              )
                            }
                          })}
                        </div>
                        <div className="chooseYourPlan">
                        <div
                          className={`radio-card col-md-4 col-xs-12 w100medium ${ optionData && (optionData.option1Data && optionData.option2Data) ? "divider-card-2": optionData && (optionData.option1Data || optionData.option2Data) ? "divider-card" : ""} `}
                          name="calculatePremium"
                          id="calculatePremium"
                          defaultChecked={
                            sectionLocalState
                              ? sectionLocalState === "calculatePremium"
                              : true
                          }
                          checked={
                            sectionLocalState
                              ? sectionLocalState === "calculatePremium"
                              : false
                          }
                          onKeyPress = {(event)=>{
                              handleEnter(
                                event,
                                { target: { value: "calculatePremium" } },
                                true
                              )
                              setSelectedOption(apiResult)
                            }
                          }
                          onClick={e => {
                              handleChange(
                                { target: { value: "calculatePremium" } },
                                true
                              )
                              setSelectedOption(apiResult)
                            }
                          }
                        >
                          <p className="card-label text-left plan-heading new-heading-font hidden-xs">
                            Calculated Premium
                          </p>
                          <div
                            className={
                              activeTab == "calculatePremium"
                                ? ""
                                : "d-xl-block d-lg-block d-md-block d-none"
                            }
                          >

                          <div
                            data-active-class="premium-payment-right-sde-box"
                            // style={{  width:"250px" }}
                            className="provider premium-payment-right-sde-box premium-payment-sec1 active"
                            tabIndex="0"
                          >
                            <div className="radio-line check-rt">
                              <label className="customradio">
                                <span className="radiotextsty"></span>
                                <input
                                  type="radio"
                                  id="hide1"
                                  defaultChecked={
                                    sectionLocalState === "calculatePremium"
                                  }
                                  checked ={
                                    sectionLocalState === "calculatePremium"
                                  }
                                  name="radio1"
                                />
                                <span className="check-premium-payment checkmark">
                                  <span className="fa fa-check check11"></span>
                                </span>

                                <div className="monthly-pre-payment-heading">
                                  <p> {standardCapital(lookup.premiumFrequency[0][journeyState.paymentFrequency])} Premium</p>
                                  <h2>₹ {applyComma(apiResult?.premium ?? '')} </h2>
                                </div>
                                <div className="gauranteed-premium-payment-content">
                                  <ul className="gauranteed-premium-payment-list">
                                    <li>
                                      <p>Sum Assured</p>
                                      <div className="img-pre"></div>
                                    </li>
                                    <li className="line-prem-pay">
                                      <div className="line-prem"></div>
                                    </li>
                                    <li>
                                      <p>Policy Term</p>
                                      <div className="img-pre-2"></div>
                                    </li>
                                  </ul>
                                </div>
                                <div className="policy-primium-payment-content">
                                  <p>
                                    <span style={{textAlign:"center"}}>₹ {insWords(apiResult?.lumpsumAmount,true)}</span>
                                 {" "}
                                    <br/>
                                   {apiResult.POLICYTERM} YEARS
                                  </p>
                                </div>
                                {/* <div className="no-mediacal">
                                  <div className="no-medical-img"></div>
                                  <p>No medical required</p>
                                </div> */}
                              </label>
                            </div>
                          </div>
                          </div>
                        </div>
                        <div className="col-md-8 w100medium">
                        <p className="card-label plan-heading new-heading-font d-lg-block d-md-none">
                            {optionData && (optionData.option1Data || optionData.option2Data ) &&'Other Recommended Options'}
                            </p>
                        <div className="col-md-12 d-flex justify-content-between flex-wrap">
                        {optionData && optionData.option1Data &&
                        (
                          <div
                            className="radio-card col-md-6 col-xs-12 w100medium"
                            name="recommendedOption"
                            id="recommendedOption"
                            checked={
                              sectionLocalState
                                ? sectionLocalState === "recommendedOption"
                                : false
                            }
                            onKeyPress = {(event)=>{
                                handleEnter(
                                  event,
                                  { target: { value: "recommendedOption" } },
                                  true
                                )
                                setSelectedOption(optionData.option1Data)
                              }
                            }
                            onClick={e => {
                                handleChange(
                                  { target: { value: "recommendedOption" } },
                                  true
                                )
                                setSelectedOption(optionData.option1Data)
                              }
                            }
                          >
                            <div
                              className={
                                activeTab.includes('recommendedOption')
                                  ? ""
                                  : "d-xl-block d-lg-block d-md-block d-none"
                              }
                            >

                            <div
                              data-active-class="premium-payment-right-sde-box"
                              className="provider premium-payment-right-sde-box premium-payment-sec2"
                              tabIndex="0"
                            >
                              <div className="radio-line check-rt">
                                <label className="customradio">
                                  <span className="radiotextsty"></span>
                                  <input
                                    type="radio"centering-cp
                                    id="hide2"
                                    name="radio1"
                                    checked={sectionLocalState === "recommendedOption"}
                                  />
                                  <span className="check-premium-payment checkmark">
                                    <span className="fa fa-check check11"></span>
                                  </span>

                                  <div className="monthly-pre-payment-heading">
                                    <p> {standardCapital(lookup.premiumFrequency[0][journeyState.paymentFrequency])} Premium</p>
                                    <h2>₹ {optionData.option1Data.premium} </h2>
                                  </div>
                                  <div className="gauranteed-premium-payment-content">
                                    <ul className="gauranteed-premium-payment-list">
                                      <li>
                                        <p>Sum Assured</p>
                                        <div className="img-pre"></div>
                                      </li>
                                      <li className="line-prem-pay">
                                        <div className="line-prem"></div>
                                      </li>
                                      <li>
                                        <p>Policy Term</p>
                                        <div className="img-pre-2"></div>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="policy-primium-payment-content">
                                    <p>
                                      <span>₹ {insWords(optionData.option1Data.lumpsumAmount)}</span>{" "}
                                      <br/>
                                      {optionData.option1Data.POLICYTERM} YEARS
                                    </p>
                                  </div>

                                </label>
                              </div>
                            </div>
                            </div>
                          </div>)
                        }

                        {optionData && optionData.option2Data && 
                        (
                          <div
                            className={`radio-card col-md-6 col-xs-12  w100medium${optionData.option1Data ? "" : "centering-cp"}`}
                            name="recommendedOption"
                            id="recommendedOptions"
                            checked={
                              sectionLocalState
                                ? sectionLocalState === "recommendedOptions"
                                : false
                            }
                            onKeyPress = {(event)=>
                              {
                                handleEnter(
                                  event,
                                  { target: { value: "recommendedOptions" } },
                                  true
                                )
                                setSelectedOption(optionData.option2Data)
                              }
                            }
                            onClick={e => {
                                handleChange(
                                  { target: { value: "recommendedOptions" } },
                                  true
                                )
                                setSelectedOption(optionData.option2Data)
                              }
                            }
                          >
                            {/* <p  className="card-label card-label--align-left plan-heading new-heading-font hidden-xs">{!['recommendedOption'].includes(sectionLocalState)?'Other Recommended Options':""}</p> */}
                            <div
                              className={
                                activeTab.includes("recommendedOption")
                                  ? ""
                                  : "d-xl-block d-lg-block d-md-block d-none d-none"
                              }
                            >

                            <div
                              data-active-class="premium-payment-right-sde-box"
                              className="provider premium-payment-right-sde-box premium-payment-sec3"
                              tabIndex="0"
                            >
                              <div className="radio-line check-rt">
                                <label className="customradio">
                                  <span className="radiotextsty"></span>
                                  <input
                                    type="radio"
                                    id="hide3"
                                    name="radio1"
                                    checked={
                                      sectionLocalState === "recommendedOptions"
                                    }
                                  />
                                  <span className="check-premium-payment checkmark">
                                    <span className="fa fa-check check11"></span>
                                  </span>

                                  <div className="monthly-pre-payment-heading">
                                    <p> {standardCapital(lookup.premiumFrequency[0][journeyState.paymentFrequency])} Premium</p>
                                    <h2>₹ {applyComma(optionData?.option2Data?.premium ?? '')}</h2>
                                  </div>
                                  <div className="gauranteed-premium-payment-content">
                                    <ul className="gauranteed-premium-payment-list">
                                      <li>
                                        <p>Sum Assured</p>
                                        <div className="img-pre"></div>
                                      </li>
                                      <li className="line-prem-pay">
                                        <div className="line-prem"></div>
                                      </li>
                                      <li>
                                        <p>Policy Term</p>
                                        <div className="img-pre-2"></div>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="policy-primium-payment-content">
                                    <p>
                                      <span>₹ {insWords(optionData.option2Data.lumpsumAmount,true)}</span>{" "}
                                      <br/>
                                     {optionData.option2Data.POLICYTERM} YEARS
                                    </p>
                                  </div>
                                  {/* <div class="no-mediacal">
                                    <div class="no-medical-img2"></div>
                                    <p>Clinic visit required</p>
                                  </div> */}
                                </label>
                              </div>
                            </div>
                            </div>
                          </div>)
                        }
                        </div>
                        </div>
                        </div>
                        </div>

                      </div>
                    </div>
                  )
                    : 
                    <div style={{textAlign:"center",fontStyle:"italic"}}>Your premium is being calculated</div>
                  }
                  <div style={{textAlign:"center",fontStyle:"italic",color:"#aaa"}}>
                      Calculated Premium is for Life Plan Option and Level Coverage Option without any Optional In-built Covers
                  </div>

                </div>
              </div>
              <RightSideBar
              sections={props.sections}
              setCallBi={props.setCallBi}
              currentSectionIndex={props.currentSectionIndex}
              setCurrentSectionIndex={props.setCurrentSectionIndex}  
            />
            </div>
          <div className="row">
            <div className="col-md-9 forbottomline w100medium">
              {apiResult?.totalPremium? <div className="total-prem-payment-price"  >
                  <div className="left-line-pre-pay"></div>
                  <h2>Total Premium: &nbsp; ₹ {selectedOption?.totalPremium}/- {standardCapital(lookup.premiumFrequency[0][journeyState.paymentFrequency])}</h2>
                  <p style={{ marginTop:'1.8rem',textAlign:'center' }} > Total premium includes the base premium of INR {selectedOption?.premium} {gstRate?.gstRateYear1 && gstRate.gstRateYear1 !== "0" ? `+ ${gstRate?.gstRateYear1}% GST of INR ${Number(gstRate?.gstRateYear1) * 0.01 * selectedOption?.premium}` : ""} </p>
                </div>:null}
            </div>
          </div>
          </div>
          <div className="container hidden-desktop-screen">
            <div className="">
              <div className="but-center text-center align-center-choose-plan " >
                <div className="provider submit-btn cen" style={{marginRight:"5px"}} tabIndex="0"
                onKeyPress={(e)=>handleEnterPrevious(e)}>
                  <a aria-hidden="true" onClick={handlePrevious}>Previous</a>
                </div>
                <input
                  type="submit"
                  className="provider previous-btn cen"
                  tabIndex="0"
                  style={{
                    color: "white",
                    padding: "14px 40px",
                    border: "none",
                    marginLeft: "8px",
                  }}
                  value="Proceed"
                  onClick={handleProceed}
                />
</div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
      {/* <!--mobile view button--> */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <div className="submit-btn cen">
                <a aria-hidden="true" onClick={handlePrevious}>Previous</a>
              </div>
              <input
                type="submit"
                className="previous-btn cen"
                style={{
                  color: "white",
                  padding: "14px 40px",
                  border: "none",
                  marginLeft: "8px",
                }}
                onClick={handleProceed}
                value="Proceed"
              />
</div>
          </div>
        </div>
      </div>
    {/* <!--mobile view button-->   */}
    </>
  )
}
